import styled, { css } from 'styled-components'

import { color, radius, spacing, typography } from '../../../themes'

export const Container = styled.div`
  display: flex;
  position: absolute;
  top: ${spacing(2)};
  left: 0;
`

interface LabelProps {
  hasContent?: boolean
}

export const Label = styled.div<LabelProps>`
  ${typography('subhead1')};
  line-height: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  color: ${color('white')};
  white-space: nowrap;
  min-width: 30px;
  z-index: 1;
  top: 6px;
  background: ${color('gradient.primary')};
  border-radius: 0 ${radius('full')} ${radius('full')} 0;

  ${({ hasContent }) =>
    hasContent &&
    css`
      padding-right: ${spacing(4)};
      padding-left: ${spacing(16)};
    `}
`

export const Circle = styled.div`
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  letter-spacing: 0.6px;
  background: ${color('white')};
  border-radius: ${radius('full')};
  position: relative;
  border: 1px solid ${color('red.01')};
  z-index: 2;
  width: 46px;
  height: 46px;
  margin-left: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${color('red.01')};
`
